import { CloseOutlined, SaveOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Row, Space, Spin } from 'antd';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { StatePieceStatus } from '../../../../../enums';
import { IAddBillableLookupListFormValues } from '../../../../../interfaces/lookup/billable';
import { IAddBillableOption } from '../../../../../interfaces/lookup/billable/data';
import { ContentHeader } from '../../../../../shared/components/appSkeleton/contentHeader/ContentHeader';
import { FetchResult } from '../../../../../shared/components/fetchResult/FetchResult';
import { ROW_GUTTER } from '../../../../../shared/Constants';
import { isError } from '../../../../../shared/helpers';
import { AppDispatch, RootState } from '../../../../../store';
import { addBillableOption } from '../../../../../store/lookupSlice/LookupActions';

export const BillableLookupListAdd = (props: any) => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const lookupSlice = useSelector((state: RootState) => state.lookupSlice);

    const onFinish = (values: IAddBillableLookupListFormValues) => {
        const body: IAddBillableOption = {
            ...(values as any),
        };

        dispatch(addBillableOption(body));
    };

    useEffect(() => {
        if (lookupSlice.detailsPage.billableOption.createStatus === StatePieceStatus.Success) {
            navigate('/admin/lookup-lists/billable', { replace: true });
        }
    }, [lookupSlice.detailsPage.billableOption.createStatus]);

    return (
        <Form
            form={form}
            name="billable-lookup-add"
            onFinish={onFinish}
            layout="vertical"
            onValuesChange={(changedValue: any, values) => {
                form.setFieldsValue(values);
            }}
        >
            <ContentHeader
                title="Manage billable option lookup list"
                breadcrumbs={[
                    {
                        breadcrumbName: 'Admin',
                        path: '/admin',
                    },
                    {
                        breadcrumbName: 'Manage lookup lists',
                        path: '/admin/lookup-lists',
                    },
                    {
                        breadcrumbName: 'Billable option',
                        path: '/admin/lookup-lists/billable',
                    },
                    {
                        breadcrumbName: 'Create',
                        path: `/admin/lookup-lists/billable/add`,
                    },
                ]}
            >
                {!isError(lookupSlice.detailsPage.billableOption.fetchStatus) && (
                    <Form.Item>
                        <Space>
                            <Button
                                icon={<CloseOutlined />}
                                onClick={() => navigate(-1)}
                                disabled={
                                    lookupSlice.detailsPage.billableOption.updateStatus === StatePieceStatus.IsFetching ||
                                    lookupSlice.detailsPage.billableOption.fetchStatus === StatePieceStatus.IsFetching
                                }
                            >
                                Close
                            </Button>
                            <Button
                                htmlType="submit"
                                type="primary"
                                icon={<SaveOutlined />}
                                loading={
                                    lookupSlice.detailsPage.billableOption.updateStatus === StatePieceStatus.IsFetching ||
                                    lookupSlice.detailsPage.billableOption.fetchStatus === StatePieceStatus.IsFetching
                                }
                            >
                                Save and close
                            </Button>
                        </Space>
                    </Form.Item>
                )}
            </ContentHeader>

            <div className="page-content">
                <Spin spinning={lookupSlice.detailsPage.billableOption.fetchStatus === StatePieceStatus.IsFetching}>
                    {isError(lookupSlice.detailsPage.billableOption.fetchStatus) ? (
                        <FetchResult status={lookupSlice.detailsPage.billableOption.fetchStatus} about={'Billable'} />
                    ) : (
                        <>
                            <Row>
                                <Col span={24}>
                                    <Space>
                                        <label className="group-label">Billable option Information</label>
                                    </Space>
                                </Col>
                            </Row>
                            <Row gutter={ROW_GUTTER}>
                                <Col span={8}>
                                    <label className="property required">Code</label>
                                    <Form.Item name="code" rules={[{ required: true, message: "'Code' is required" }]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <label className="property required">Description</label>
                                    <Form.Item name="description" rules={[{ required: true, message: "'Description' is required" }]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>&nbsp;</Col>
                            </Row>
                        </>
                    )}
                </Spin>
            </div>
        </Form>
    );
};
